"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getRootModule;

var _SettingsModule = _interopRequireDefault(require("settings-ui-sdk/app/SettingsModule"));

var _urls = require("settings-ui-sdk/utils/urls");

var _accountDefaults = _interopRequireDefault(require("../modules/account-defaults"));

var _analyticsAndTracking = _interopRequireDefault(require("../modules/analytics-and-tracking"));

var _ecommerce = _interopRequireDefault(require("../modules/ecommerce"));

var _marketing = _interopRequireDefault(require("../modules/marketing"));

var _sales = _interopRequireDefault(require("../modules/sales"));

var _quotas = _interopRequireDefault(require("../modules/quotas"));

var _exampleHiddenModule = _interopRequireDefault(require("../modules/example-hidden-module"));

var rootModule = undefined;

function getRootModule() {
  if (!rootModule) {
    rootModule = new _SettingsModule.default({
      route: (0, _urls.getRootUrl)(),
      modules: [_accountDefaults.default, _analyticsAndTracking.default, _ecommerce.default, _marketing.default, _sales.default, _quotas.default, _exampleHiddenModule.default],
      dsn: 'https://a91342c4d48e0eebeb40d0e1fa9d291c@exceptions.hubspot.com/132521',
      newRelicAppId: '41130873'
    });

    rootModule._createPath();
  }

  return rootModule;
}

module.exports = exports.default;